import { deriveQuoteActiveTabFromPathname } from './active-tab';

export const getPageViewEventProperties = (pathname: string) => {
  if (pathname === '/quote' || pathname === '/quote/' || !pathname.startsWith('/quote/')) {
    return {};
  }
  return { page_tab: deriveQuoteActiveTabFromPathname(pathname) };
};
